import React from 'react';

const MenuItem = ({ link, title }) => {

  return(
    <li className="pb-2.5 border-b border-solid border-dorot-purple flex justify-between items-center">
      <a href={link} className="text-white text-_1625 px-7.5 font-goldplay font-semibold">{title}</a>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="text-white" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
      </svg>
    </li>
  )
}

export default MenuItem;